import { createContext } from 'react';

type Props = {
  submit: () => void;
};

type ItemFormContextType = {
  submit: () => void;
};

const initialState = {
  submit: () => {},
};

export const ItemFormContext = createContext<ItemFormContextType>(initialState);

export const useItemFormContext = ({ submit }: Props): ItemFormContextType => {
  return {
    submit,
  };
};
